import LoadingValue from './LoadingValue'

export default LoadingValue
